export const DRAWER_PADDING_OFFSET = 100;
export const POPOUT_PADDING_OFFSET = 120;